import { api } from "../api";
import type { BillingDetails } from "./billing-details.types";

export const billingDetailsApi = {
    get: async (): Promise<BillingDetails> => {
        const response = await api.get("/billing-details/");
        return response.data;
    },

    update: async (
        details: BillingDetails,
    ): Promise<{ message: string; billing_details: BillingDetails }> => {
        const response = await api.put("/billing-details/", details);
        return response.data;
    },
};
